import React from "react";
import { Route } from "react-router";
import { ProductLaunchesPage } from "pages/Products/ProductLaunches";
import { ProtectedRoute } from "./ProtectedRoute";
import { UserNavigationGroup, UserRole } from "../types/declarations/enums.ts";

export const ProductsRoutes = ProtectedRoute({
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				path="product-launches"
				element={<ProductLaunchesPage />}
			/>
		</>
	)
});
